import React from "react";
import classnames from "classnames";
import OfferIcon from "@components/icons/Offer";

export function SportSubheaderIcons({
	sportAbrv,
	categoryAbrv,
}: {
	sportAbrv: string;
	categoryAbrv: string;
}) {
	const iconWrapper = "header__icon u-icon u-icon--med";
	const iconBase = "header__icon__inner u-icon--base";

	return (
		<div className="header__icons">
			<OfferIcon
				type="sport"
				sport={sportAbrv}
				wrapperClassName={classnames(
					"header__icon--sport",
					iconWrapper
				)}
				className={iconBase}
			/>

			<OfferIcon
				type="category"
				sport={sportAbrv}
				category={categoryAbrv}
				wrapperClassName={classnames(
					"header__icon--category",
					iconWrapper
				)}
				className={classnames(iconBase, "u-icon--round")}
			/>
		</div>
	);
}
